export const resultIds = data => {
  const listings = data.data;
  return listings
    .filter(l => !l.attributes.deleted && l.attributes.state === 'published')
    .map(l => l.id);
};

export const getCategoryLevels = publicData =>
  Object.keys(publicData || {}).reduce((levels, key) => {
    if (key.startsWith('categoryLevel') && publicData[key]) {
      const index = key.replace('categoryLevel', '');
      levels[`pub_categoryLevel${index}`] = publicData[key];
    }
    return levels;
  }, {});
